import { getDefaultStore } from "jotai";
import { serverWakingAtom } from "../stores/serverWaking";

// onServerDown is called from the api layer when a read sees the backend as down
// (502/503/504). It flips the global waking flag (ServerWakingOverlay takes over)
// and, on stg only, fires a fire-and-forget GET to a /health/* path.
//
// Why /health/live: that path rides the `/health/*` CloudFront cache behavior,
// which sits on the `api-failover` origin group (stg cdn.tf). While the services
// are scaled to 0 the ALB returns 503, so CloudFront fails over to the wake
// Lambda's Function URL — the side effect of that failover is the Lambda raising
// each service's autoscaling floor to 1 (stg_wake.tf). So one ping trips the
// wake. prod never scales to zero and has no failover origin, so the ping is
// skipped there.
let lastPingAt = 0;

export function onServerDown(): void {
  getDefaultStore().set(serverWakingAtom, true);

  // Debounce: a full-page load fires ~20 reads at once, each 503. The wake Lambda
  // is idempotent, but one ping per outage is plenty.
  const now = Date.now();
  if (now - lastPingAt < 10_000) return;
  lastPingAt = now;

  // stg hosts are {service}.stg.orbitlens.io — only they scale to zero + wake.
  if (/(^|\.)stg\.orbitlens\.io$/.test(window.location.hostname)) {
    void fetch("/health/live", { method: "GET", cache: "no-store" }).catch(() => {
      // Fire-and-forget: the point is the failover side effect, not the response.
    });
  }
}
